import React from "react";
import { REGENERUS_PRIVACY_SLUG } from "@/core/urls";
import PolicyPage from "./PolicyPage";

function RegenerusPrivacyPolicyPage() {
  return <PolicyPage slug={REGENERUS_PRIVACY_SLUG} />;
}

export default RegenerusPrivacyPolicyPage;
